import { render, staticRenderFns } from "./LayoutApp.vue?vue&type=template&id=233fe442&scoped=true"
import script from "./LayoutApp.vue?vue&type=script&lang=js"
export * from "./LayoutApp.vue?vue&type=script&lang=js"
import style0 from "./LayoutApp.vue?vue&type=style&index=0&id=233fe442&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233fe442",
  null
  
)

export default component.exports